import { z } from 'zod';
import { requiredNamedObjectSchema } from './named-object.js';
import { nullishToUndefined } from '../utils/nullishToUndefined.js';
export const frequencyRepetitionMaxValue = 50;
export const frequencyPeriodFrequencyMaxValue = 1440;
export const frequencySchema = z.object({
    repetition: z
        .number()
        .int()
        .min(1)
        .max(frequencyRepetitionMaxValue)
        .nullish()
        .transform(nullishToUndefined)
        .optional(),
    period: requiredNamedObjectSchema.nullish().transform(nullishToUndefined).optional(),
    periodFrequency: z
        .number()
        .int()
        .min(1)
        .max(frequencyPeriodFrequencyMaxValue)
        .nullish()
        .transform(nullishToUndefined)
        .optional(),
});
export function toFrequency(frequency) {
    const result = frequencySchema.safeParse(frequency);
    if (!result.success) {
        throw new Error(`Invalid Frequency object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=frequency.js.map